import React from 'react'
import {Link} from 'react-router-dom'
import Sectiontitle from '../section-title'
import couple1 from '../../images/couple/sup-pic.jpg'
import couple2 from '../../images/couple/thu-pic.jpg'
import couple3 from '../../images/couple/2.png'
import './style.css'

const Couple = () => {
    return(
        <div id="couple" className="about-wrap">
            <div className="couple-area section-padding pb-70">
                <Sectiontitle section={'Happy Couple'}/>
                <div className="container">
                    <div className="couple-wrap">
                        <div className="row">
                            <div className="col-lg-5 col-md-12 col-sm-12 couple-single">
                                <div className="couple-wrap couple-wrap-2">
                                    <div className="couple-img">
                                        <img src={couple1} alt="thumb"/>
                                    </div>
                                    <div className="couple-text">
                                        <div className="couple-content">
                                            <h3>SUPUNI</h3>
                                            <p>Hi there! I’m a shy but fun-loving girl who’s happiest when surrounded by flowers. They’ve always been my little joy, and then came him—the guy who made my life bloom by bringing me flowers every single day. It’s no wonder I fell in love with him! Now, we’re starting the most beautiful chapter of our story, and I can’t wait to share it with you all.</p>
                                        </div>
                                        <div className="social-icon">
                                            <ul className="d-flex">
                                                <li><Link to='https://instagram.com/__supun_97__/?igsh=dzNvZGg4OHNnc3F2&utm_source=qr#' target="_blank" rel="noopener noreferrer"><span className="fa fa-instagram"></span></Link></li>
                                                <li><Link to='https://www.facebook.com/share/1AxtgYKDHw/?mibextid=wwXIfr' target="_blank" rel="noopener noreferrer"><span className="fa fa-facebook"></span></Link></li>
                                                <li><Link to='https://www.linkedin.com/in/supuninuwarapaksha/' target="_blank" rel="noopener noreferrer"><span className="fa fa-linkedin"></span></Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 couple-single">
                                <div className="couple-shape">
                                   <img src={couple3} alt="shape"/>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-12 col-sm-12 couple-single">
                                <div className="couple-wrap couple-wrap-3">
                                    <div className="couple-img couple-img-2">
                                        <img src={couple2} alt="thumb"/>
                                    </div>
                                    <div className="couple-text">
                                        <div className="couple-content">
                                            <h3>THUSHAL</h3>
                                            <p>And this is my not-so-shy boyfriend. He’s definitely more talkative than I am—a kind-hearted person who is always ready to help anyone in need. A workaholic until I came along, his annoying girlfriend, here to make sure he’s stuck with me for the rest of his life, sharing every adventure together.<br></br></p>
                                        </div>
                                        <div className="social-icon">
                                            <ul className="d-flex">
                                                <li><Link to='https://www.instagram.com/t_himaranga/profilecard/?igsh=cjUydnV2dDl4YXF0' target="_blank" rel="noopener noreferrer"><span className="fa fa-instagram"></span></Link></li>
                                                <li><Link to='https://www.facebook.com/share/19X3VPZjvb/' target="_blank" rel="noopener noreferrer"><span className="fa fa-facebook"></span></Link></li>
                                                <li><Link to='https://www.linkedin.com/in/t-himaranga-ponnamperuma?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app' target="_blank" rel="noopener noreferrer"><span className="fa fa-linkedin"></span></Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             
        </div>
        
    )
}

export default Couple;